import { render, staticRenderFns } from "./DialogFalhaSignatarioWhatsapp.vue?vue&type=template&id=b8826f96"
import script from "./DialogFalhaSignatarioWhatsapp.vue?vue&type=script&lang=js"
export * from "./DialogFalhaSignatarioWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./DialogFalhaSignatarioWhatsapp.vue?vue&type=style&index=0&id=b8826f96&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports